/**
 * Wrap an element
 *
 * @param el
 * @param wrapper
 */
export function wrapEl(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}


/**
 * Insert new node after reference node
 *
 * @param referenceNode
 * @param newNode
 */
export function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}


/**
 * Debounce
 *
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * credits: underscore.js
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {Function}
 */
export function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        const context = this, args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}


/**
 * Replace string by prefix
 *
 * Replace every occurrence in a string starting with provided prefix
 *
 * @param string
 * @param prefix
 * @param value
 * @returns {*}
 */
export function replaceStringByPrefix(string, prefix, value) {
    const regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    return string.replace(regx, `${prefix}${value}`);
}


export const replaceFieldvalue = (e, pattern, modifiers) => {
    e.preventDefault();
    const regex = new RegExp(pattern, modifiers);

    let pastedText = '';

    if (e.clipboardData && e.clipboardData.getData) {// Standards Compliant FIRST!
        pastedText = e.clipboardData.getData('text/plain');
    } else if (window.clipboardData && window.clipboardData.getData) {// IE
        pastedText = window.clipboardData.getData('Text');
    }

    e.target.value = pastedText.replace(regex, '');
};
